module.exports = __webpack_public_path__ + "static/media/logo5.a17eff21.png";